import _ from "lodash";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { Action, User } from "../constants/interfaces";
import api from "../utils/api";

interface State {
  error: Error | null;
  loading: boolean;
  user: User | null;
}

export function getInitialState(): State {
  return {
    loading: false,
    error: null,
    user: null
  };
}

export const userTypes = {
  GET_USER_DETAILS_REQUEST: "GET_USER_DETAILS_REQUEST",
  GET_USER_DETAILS_RESPONSE: "GET_USER_DETAILS_RESPONSE",
  UPDATE_USER_DETAILS_REQUEST: "UPDATE_USER_DETAILS_REQUEST",
  UPDATE_USER_DETAILS_RESPONSE: "UPDATE_USER_DETAILS_RESPONSE"
};

export const userActions: any = {
  // Gets full user details from Case Manager
  getUserDetails: () => async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    dispatch({ type: userTypes.GET_USER_DETAILS_REQUEST });
    try {
      const { data: user } = await api.get("/contact/getUserContactDetails");

      dispatch({
        type: userTypes.GET_USER_DETAILS_RESPONSE,
        payload: user,
        error: false
      });
      return user;
    } catch (e) {
      dispatch({
        type: userTypes.GET_USER_DETAILS_RESPONSE,
        payload: e,
        error: true
      });
      return e;
    }
  },

  updateUserDetails: (user: User, callback?: () => void) => async (
    dispatch: ThunkDispatch<{}, {}, AnyAction>
  ) => {
    dispatch({ type: userTypes.UPDATE_USER_DETAILS_REQUEST });
    try {
      await api.put(
        `/contact/updateUserContactDetails/${user.cmAcmCaseIdentifier}`,
        user
      );
      dispatch({
        type: userTypes.UPDATE_USER_DETAILS_RESPONSE,
        payload: user,
        error: false
      });
      if (callback) callback();
    } catch (e) {
      dispatch({
        type: userTypes.UPDATE_USER_DETAILS_RESPONSE,
        payload: e,
        error: true
      });
      return e;
    }
  }
};

export default function user(state = getInitialState(), action: Action) {
  const { type, payload, error } = action;
  switch (type) {
    case userTypes.GET_USER_DETAILS_REQUEST: {
      return { ...state, loading: true, error: null };
    }

    case userTypes.GET_USER_DETAILS_RESPONSE: {
      if (error) {
        // If something goes wrong, return existing user state
        return { ...state, loading: false, error: payload };
      }
      return {
        ...state,
        loading: false,
        error: null,
        user: mergeUser(state.user, payload)
      };
    }

    case userTypes.UPDATE_USER_DETAILS_REQUEST: {
      return { ...state, loading: true, error: null };
    }

    case userTypes.UPDATE_USER_DETAILS_RESPONSE: {
      if (error) {
        return { ...state, loading: false, error: payload };
      }
      return {
        ...state,
        loading: false,
        error: null,
        user: mergeUser(state.user, payload)
      };
    }
  }
  return state;
}

export const mergeUser = (existingUser: User | null, newUser: User): User => {
  return existingUser ? _.merge({ ...existingUser }, newUser) : newUser;
};
